import { applyMiddleware, createStore, compose } from 'redux';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import reducers from './reducers';
import sagas from './sagas';

const sagasMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = (process.env.NODE_ENV === 'production')
  ? applyMiddleware(sagasMiddleware)
  : composeEnhancers(applyMiddleware(logger, sagasMiddleware));

const store = createStore(reducers, middleware);

sagasMiddleware.run(sagas);

export default store;
